module.exports = __webpack_public_path__ + "img/PDAC1_B.701fc5fb.png";